import styled from 'styled-components';

const Sticky = styled.div`
  &.sticky-left,
  &.sticky-right {
    position: sticky;
    z-index: 1;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      width: 20px;
      height: 100%;
      pointer-events: none;
    }
  }

  &.sticky-left {
    // Negative value here supports the trick of toggling sticky column shadows (see AdjustStickyColumns.tsx)
    // Subpixel value seems to not do the trick in Chrome anymore
    left: -1px;

    &:not(:has(~ .sticky-left)) {
      &:not(.hide-left-shadow &):before {
        display: none;
      }

      &:after {
        box-shadow: inset 10px 0 8px -8px rgba(2, 2, 2, 0.15);
        left: 100%;
      }
    }
  }

  &.sticky-right {
    // Negative value here supports the trick of toggling sticky column shadows (see AdjustStickyColumns.tsx)
    // Subpixel value seems to not do the trick in Chrome anymore
    right: -1px;

    &:not(& ~ .sticky-right):after {
      box-shadow: inset -10px 0px 8px -8px rgba(2, 2, 2, 0.15);
      right: 100%;
    }
  }
`;

export const stickyStyle: string = (Sticky.componentStyle as any).rules
  .filter((r: any) => typeof r === 'string')
  .join('');
